import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap"

//i18n
import { withTranslation } from "react-i18next"
// Redux
import { connect } from "react-redux"
import { Link } from "react-router-dom"
import withRouter from "components/Common/withRouter"

const ProfileMenu = props => {
  // Declare a new state variable, which we'll call "menu"
  const [menu, setMenu] = useState(false)

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block"
      >
        <DropdownToggle
          className="btn header-item "
          id="page-header-user-dropdown"
          tag="button"
          style={{ display: "flex", alignItems: "center" }}
        >
          <span className="avatar-xs ">
            <span
              className="avatar-title rounded-circle "
              style={
                props?.userInfo?.role === "CustomerAdmin"
                  ? { background: "#fa7c1f" }
                  : {}
              }
            >
              {props?.userInfo?.nameSurname.toString().charAt(0)}
            </span>
          </span>
          <span className="d-none d-xl-inline-block ms-2 me-1">
            <span style={{ fontWeight: "bold" }}>
              {props?.userInfo?.nameSurname}{" "}
              <span style={{ opacity: "0.5", fontSize: 12 }}>
                {" "}
                [ {props?.userInfo?.role}{" "}
                {props?.userInfo?.actions &&
                  ` - ${props?.userInfo?.actions[0]}`}{" "}
                ]
              </span>
            </span>
          </span>
          {/* <i className="mdi mdi-chevron-down d-none d-xl-inline-block" /> */}
        </DropdownToggle>
        {/* <DropdownMenu className="dropdown-menu-end">
          <DropdownItem tag="a" href="#">
            <i className="bx bx-user font-size-16 align-middle me-1" />
            {props.t("Profile")}{" "}
          </DropdownItem> */}
        {/* <DropdownItem tag="a" href="/crypto-wallet">
            <i className="bx bx-wallet font-size-16 align-middle me-1" />
            {props.t("My Wallet")}
          </DropdownItem>
          <DropdownItem tag="a" href="#">
            <span className="badge bg-success float-end">11</span>
            <i className="bx bx-wrench font-size-16 align-middle me-1" />
            {props.t("Settings")}
          </DropdownItem> */}
        {/* <DropdownItem tag="a" href="auth-lock-screen">
            <i className="bx bx-lock-open font-size-16 align-middle me-1" />
            {props.t("Lock screen")}
          </DropdownItem> */}
        {/* 
          <div className="dropdown-divider" />
          <Link
            to="/logout"
            className="dropdown-item"
            onClick={() => {
              localStorage.removeItem("access_token")
              localStorage.removeItem("authUserV0")
            }}
          >
            <i className="bx bx-power-off font-size-16 align-middle me-1 text-danger" />
            <span>{props.t("Logout")}</span>
          </Link>
        </DropdownMenu> */}
      </Dropdown>
    </React.Fragment>
  )
}

ProfileMenu.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any,
}

const mapStatetoProps = state => {
  const { error, success } = state.Profile
  return { error, success }
}

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(ProfileMenu))
)
